import { useAppStore } from "@/stores/appStore"
import { useAuthStore } from "@/stores/authStore"
import { canNavigate } from "@layouts/plugins/casl"
import { getSchoolStaff } from "@/services/ApiUrlService"

export const setupGuards = (router) => {
  // 👉 router.beforeEach
  // Docs: https://router.vuejs.org/guide/advanced/navigation-guards.html#global-before-guards
  router.beforeEach(async (to, from) => {
    //console.log('start routing')
    const appStore = useAppStore()
    /*
     * If it's a public route, continue navigation. This kind of pages are allowed to visited by login & non-login users. Basically, without any restrictions.
     * Examples of public routes are, 404, under maintenance, etc.
     */
    if (to.name === "campaign-id")
      useAppStore().yearSelected = to.params?.id || CURRENT_YEAR
    if (to.meta.public) return

    /**
     * Check if user is logged in by checking if token & user data exists in local storage
     * Feel free to update this logic to suit your needs
     */
    const isLoggedIn = !!(
      useCookie("user").value && useCookie("accessToken").value
    )
    const termsAccepted = useCookie("user").value?.termsAccepted
    // console.log('termsAccepted', termsAccepted)
    // && useCookie('userAbilityRules').value
    //console.log(isLoggedIn, 'isLoggedIn guard')
    /*
          If user is logged in and is trying to access login like page, redirect to home
          else allow visiting the page
          (WARN: Don't allow executing further by return statement because next code will check for permissions)
         */
    if (to.meta.unauthenticatedOnly) {
      if (isLoggedIn) {
        console.log("is login page, and logged in")
        return "/"
      } else return undefined
    }
    // console.log(canNavigate(to), to)
    if (!canNavigate(to)) {
      if (isLoggedIn) {
        console.log("go to not authorized")
        return { name: "not-authorized", params: { "previous-page": to } }
      }
      return {
        name: "login",
        query: {
          ...to.query,
          to: to.fullPath !== "/" ? to.path : undefined,
        },
      }
    } else if (!isLoggedIn) {
      if (to.path.indexOf("/student/") !== -1) {
        return
      } else if (!useCookie("user").value && !useCookie("accessToken").value) {
        // && useCookie('userAbilityRules').value
        useAuthStore().logout()
      }
    } else if (isLoggedIn && !termsAccepted && to.name !== "reglement") {
      return { name: "reglement" }
    }
    if (isLoggedIn) {
      const authStore = useAuthStore()

      if (!authStore.profileCache) {
        const schoolStaffId = useCookie("schoolStaffId").value
        const { data, error } = await useApi(
          `${getSchoolStaff}/${schoolStaffId}`
        )
        if (error.value) {
          authStore.logout()
        }
        authStore.setProfileUser(data.value)
      }
    }
    // todo: clearRoute for cachedGetRequests
    const shouldBeClearedList = Object.keys(appStore.autoLoad).find((key) => {
      const config = appStore.autoLoad[key]
      return Array.isArray(config.clearRoute)
        ? config.clearRoute.includes(from.name)
        : config.clearRoute === from.name
    })
    if (shouldBeClearedList) {
      appStore.autoLoad[shouldBeClearedList].list = []
      appStore.autoLoad[shouldBeClearedList].touched = false
    }
  })
}
